interface StatusDotProps {
  color?: "red" | "amb" | "grn" | "blue" | "ink";
  size?: "sm" | "md" | "lg";
  pulse?: boolean;
  className?: string;
}

const colorMap = {
  red: "bg-neg",
  amb: "bg-flag",
  grn: "bg-pos",
  blue: "bg-info",
  ink: "bg-faint",
};
const sizeMap = {
  sm: "w-2 h-2",
  md: "w-2.5 h-2.5",
  lg: "w-3 h-3",
};

export default function StatusDot({ color = "ink", size = "md", pulse = true, className = "" }: StatusDotProps) {
  const dot = colorMap[color];
  const sz = sizeMap[size];
  return (
    <span className={`relative inline-flex items-center justify-center ${sz} ${className}`}>
      {pulse && (
        <span
          className={`absolute inset-0 rounded-full ${dot} animate-pulse-dot`}
          style={{ transformOrigin: "center" }}
        />
      )}
      <span className={`relative rounded-full ${dot} ${sz} ${pulse ? "animate-pulse-glow" : ""}`} />
    </span>
  );
}
